var map = {
	"./1.fbx": 3907,
	"./Accenture.png": 8226,
	"./FitPeo Dashboard.png": 4617,
	"./HackerRank5star.png": 700,
	"./Home Design.png": 2808,
	"./Screenshot (1106).png": 7764,
	"./Screenshot (1107).png": 9750,
	"./Screenshot (1108).png": 7621,
	"./Screenshot (1110).png": 8327,
	"./Screenshot (1112).png": 1009,
	"./Screenshot (1114).png": 3333,
	"./Screenshot (1340).png": 305,
	"./Screenshot (1342).png": 7177,
	"./Skill.png": 7102,
	"./Todo.png": 8216,
	"./Untitled design (10).png": 318,
	"./Untitled design (8).png": 4639,
	"./aws (1).png": 5693,
	"./aws.png": 2036,
	"./azure (1).png": 145,
	"./azure.png": 8731,
	"./bootstrap (1).png": 9933,
	"./bootstrap (2).png": 1638,
	"./bootstrap.png": 5209,
	"./c (1).png": 2323,
	"./c-.png": 7021,
	"./c-logo.png": 7397,
	"./c-plus-plus.png": 1818,
	"./c.png": 826,
	"./call.png": 4217,
	"./canva.png": 8557,
	"./canva1.png": 1033,
	"./coding (1).png": 5085,
	"./coding.png": 1465,
	"./css-3.png": 3685,
	"./css.png": 1262,
	"./data-structures-algorithms.webp": 8634,
	"./database (1).png": 2333,
	"./database (2).png": 5411,
	"./database (3).png": 9681,
	"./database.png": 468,
	"./django (1).png": 4523,
	"./django.png": 666,
	"./elastic-search.png": 9042,
	"./elastic.png": 2446,
	"./express (1).png": 8951,
	"./express (2).png": 407,
	"./express (3).png": 1937,
	"./express.png": 1929,
	"./figma (1).png": 3203,
	"./figma (2).png": 2715,
	"./figma.png": 4458,
	"./frt.png": 9320,
	"./github (1).png": 1042,
	"./github.png": 6368,
	"./google-plus.png": 9196,
	"./hackerrank.png": 2628,
	"./heroku (1).png": 1982,
	"./heroku.png": 5644,
	"./hibernate (2).png": 197,
	"./hibernate.png": 8882,
	"./html (2).png": 6332,
	"./html-5.png": 4783,
	"./html.png": 80,
	"./html3.png": 2141,
	"./internshala.svg": 9556,
	"./java (1).png": 3836,
	"./java-script (1).png": 4615,
	"./java-script.png": 3413,
	"./java.png": 5062,
	"./java.webp": 6418,
	"./jest (1).png": 5107,
	"./jest.png": 2823,
	"./jsp-file (1).png": 8969,
	"./jsp-file.png": 7616,
	"./leetcode.png": 130,
	"./link.png": 471,
	"./linked.png": 9579,
	"./linkedin.png": 4983,
	"./logo-udemy.svg": 1188,
	"./mongodb (1).png": 9411,
	"./mongodb.png": 8927,
	"./next.png": 6419,
	"./node-js.png": 2669,
	"./nodejs (2).png": 4410,
	"./nuxt-dot-js (1).png": 444,
	"./nuxt-dot-js.png": 8920,
	"./onspot.PNG": 7938,
	"./photo_2022-06-30_01-06-42-removebg-preview.png": 3262,
	"./photo_2022-06-30_01-06-43-removebg-preview.png": 6417,
	"./photo_2022-06-30_01-06-43__2_-removebg-preview.png": 5438,
	"./photo_2022-06-30_01-06-43__3_-removebg-preview.png": 7738,
	"./php (1).png": 5522,
	"./php.png": 2493,
	"./postman (1).png": 4395,
	"./postman.png": 884,
	"./project.png": 3670,
	"./python (1).png": 3297,
	"./python.png": 4720,
	"./react (2).png": 152,
	"./react (3).png": 2191,
	"./redis.png": 7744,
	"./redux (1).png": 3125,
	"./redux.png": 5640,
	"./senior.png": 1472,
	"./sk.png": 7801,
	"./sql-server (1).png": 6490,
	"./sql-server.png": 9694,
	"./sun.png": 4893,
	"./sunny.png": 5073,
	"./tcs.PNG": 9859,
	"./tcs1.png": 5066,
	"./twitter.png": 3900,
	"./typescript (1).png": 2830,
	"./typescript (4).png": 2760,
	"./typescript.png": 4642,
	"./vue-dot-js.png": 9714,
	"./vue-js.png": 1202,
	"./web-development.webp": 2099,
	"./webpack (1).png": 705,
	"./webpack.png": 9585,
	"./website-design.png": 4671,
	"./wings1.PNG": 3256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5160;